import React, { useEffect, useState } from 'react';
import { CTBox } from '../style/StyledComponents';
import PodcastForm from './PodcastForm';
import { buildPodcastFromHistory, getImage } from './podcastUtils';
import PodcastBoard from './PodcastBoard';
import { deleteNote, getAllSavedNotes } from '../../storage/PodcastLocalStorage';
import { Divider, CircularProgress, Typography } from '@mui/material';
import PodcastHistoryBoard from './PodcastHistoryBoard';
import PodcastIntroSection from './PodcastIntro';
import PodcastFeatures from './PodcastFeatures';
import PodcastFaqSection from './PodcastFaq';
import PodcastIntroImages from './PodcastIntroImages';
import { Helmet } from 'react-helmet';
import PodcastHelmet from './PodcastHelmet';

const checkIfUserHasWatchedPodcasts = (watchedPodcasts) => {
  return watchedPodcasts && watchedPodcasts.length > 0;
};

const Spacer = ({ height }) => (
  <div style={{ height }} />
);


function PodcastComponent() {
 // const [rssFeed, setRssFeed] = useState("https://allinchamathjason.libsyn.com/rss");
  const [rssFeed, setRssFeed] = useState("");
  const [rowData, setRowData] = useState([]);
  const [submitClick, setSubmitClick] = useState(false);
  const [feedUrls, setFeedUrls] = useState([
    { name: "WebRush", url: "https://feeds.simplecast.com/tOjNXec5" },
    { name: "The Evil Tester Show", url: "https://feed.pod.co/the-evil-tester-show" },
    { name: "The Change log", url: "https://changelog.com/podcast/feed" },
    { name: "JS Party", url: "https://changelog.com/jsparty/feed" },
    { name: "Founders Talk", url: "https://changelog.com/founderstalk/feed" },
    { name: "Art of manliness", url: "http://feeds2.feedburner.com/TheArtOfManliness" },
    { name: "All in", url: "https://allinchamathjason.libsyn.com/rss" },
  ]);

  const [watchedPodcasts, setWatchedPodcasts] = useState({});
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const notes = getAllSavedNotes();
    const podcasts = [];
    if (notes) {
      for (const [key, value] of Object.entries(notes)) {
        const podcast = buildPodcastFromHistory(key, value);
        podcasts.push(podcast);
      }
    }
    podcasts.sort((a, b) => b.updateTime - a.updateTime);
    setWatchedPodcasts(podcasts);
  }, []);

  const handleDeleteClickOnHistory = (id) => {
    deleteNote(id);
    const notes = getAllSavedNotes();
    const podcasts = [];
    if (notes) {
      for (const [key, value] of Object.entries(notes)) {
        const podcast = buildPodcastFromHistory(key, value);
        podcasts.push(podcast);
      }
    }
    podcasts.sort((a, b) => b.updateTime - a.updateTime);
    setWatchedPodcasts(podcasts);
  };

  const handleLoadFeedClick = () => {
    if (!rssFeed) return;
    if (rssFeed.trim() === "") return;

    setLoading(true);

    fetch(rssFeed)
      .then((response) => response.text())
      .then((str) => new window.DOMParser().parseFromString(str, 'text/xml'))
      .then((data) => {
        const itemList = data.querySelectorAll('item');
        const channelImage = getImage(data);
        const items = [];
        itemList.forEach((el) => {
          const itemImage = getImage(el) || channelImage;
          items.push({
            pubDate: new Date(el.querySelector('pubDate').textContent),
            title: el.querySelector('title').innerHTML,
            mp3: el.querySelector('enclosure').getAttribute('url'),
            description: el
              .querySelector('description')
              .textContent.replace(/(<([^>]+)>)/gi, ''),
            uid: el.querySelector('guid')?.textContent,
            image: itemImage,
          });
        });
        setRowData(items);
        setSubmitClick(true);
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
  };

  return (
    <>
    <PodcastHelmet />
    {/*<Helmet>Free Podcast Notes Maker</Helmet>  */}
    <CTBox>
      <PodcastIntroSection />
      <PodcastForm rssFeed={rssFeed} setRssFeed={setRssFeed} handleSubmit={handleLoadFeedClick} />
      {loading ? <CircularProgress /> : submitClick && (
        rowData.length > 0 ? (
          <PodcastBoard podcasts={rowData} rssFeed={rssFeed} />
        ) : (
          <Typography paragraph>No podcasts found. Please check your RSS feed.</Typography>
        )
      )}
      {rowData.length == 0 && <PodcastIntroImages /> }
      {/*<Spacer height={"20px"} />*/}
      {checkIfUserHasWatchedPodcasts(watchedPodcasts) && <Divider flexItem />}
      {checkIfUserHasWatchedPodcasts(watchedPodcasts) && (
        <PodcastHistoryBoard
          podcasts={watchedPodcasts}
          handleDeleteClick={handleDeleteClickOnHistory}
        />
      )}
      {<Divider flexItem />}
      {<PodcastFeatures />}
      {<Divider flexItem />}
      <PodcastFaqSection />
    </CTBox>
    </>
  );
}

export default PodcastComponent;
